

























































import { Vue, Component } from 'vue-property-decorator'
import RegistrationProgress from '../components/RegistrationProgress.vue'
import AddressSection from '../components/AddressSection.vue'
import PriceCards from '../components/PriceCards.vue'
import RegistrationPaymentCard from '../components/RegistrationPaymentCard.vue'
import RegistrationConfirmation from '../components/RegistrationConfirmation.vue'
import ChoosePlan from '../components/ChoosePlan.vue'
import { ActionTypes } from '../store/modules/customer/types'

@Component({
    components: {
        AddressSection,
        PriceCards,
        RegistrationProgress,
        RegistrationPaymentCard,
        RegistrationConfirmation,
        ChoosePlan,
    },
})
export default class Registration extends Vue {
    product = null
    package: string = 'original'

    created(): void {
        this.$store.dispatch(ActionTypes.GET_PRODUCTS)
        // To delete card information(saved in local storage) at registration
        this.$store.commit(ActionTypes.GET_CARD_FAILURE)
        // 追加
        if (this.$store.state.customer.selectedProduct) {
            this.product = this.$store.state.customer.selectedProduct
            this.package = this.getOption(this.product)
        }
    }
    getOption(selectedPlan: any): string {
        if (
            selectedPlan.id === 'ME_Plan_1' ||
            selectedPlan.id === 'ME_Plan_2' ||
            selectedPlan.id === 'ME_Plan_3'
        ) {
            return 'original'
        } else if (selectedPlan.id === 'ME_Plan_3_1') {
            return 'kids'
        } else {
            return 'family'
        }
    }
    call(product: any): void {
        this.product = product
    }
}
